import React, { FC } from 'react'
import classNames from 'classnames'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { ScheduleType } from 'types/schedule'
import useDaysOfWeekName from 'hooks/bread/useDaysOfWeekName'
import { StockUnionType } from 'types/stock'

type Props = {
  schedule: ScheduleType
  type: StockUnionType
}

const DefaultStocksDetailCard: FC<Props> = (props) => {
  const { schedule, type } = props

  // 当日取り置きの都度配信の場合
  if (
    type === 'daily' &&
    schedule.days_of_week.length === 0 &&
    schedule.default_stocks.every((defaultStock) => {
      return defaultStock.pickupable_time === '' && defaultStock.stock === 0
    })
  ) {
    return <p className={classNames(text.font_small, text.font_bold, text.color_caution)}>都度配信</p>
  } else {
    const daysOfWeekName = useDaysOfWeekName(schedule)
    return (
      <React.Fragment>
        <p className={classNames(text.font_small, text.font_bold)}>{daysOfWeekName}</p>
        {schedule.default_stocks.map((defaultStock) => (
          <React.Fragment key={defaultStock.pickupable_time}>
            <Spacer size={8} />
            <p className={text.font_small}>
              <span className={text.font_bold}>{defaultStock.pickupable_time}</span>
              {type === 'daily' && <span>に解禁される在庫数：</span>}
              {type === 'preorder' && <span>に解禁される販売上限数：</span>}
              <span className={text.font_bold}>{defaultStock.stock}個</span>
            </p>
          </React.Fragment>
        ))}
      </React.Fragment>
    )
  }
}

export default DefaultStocksDetailCard
